import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import NotificationsList from "../../../../containers/NotificationsList";
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import NotificationStats from "../../../../containers/NotificationStats";
import Api from "../../../../services/Api";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
    };
  }

  async componentDidMount() {
    await this.fetchStatus();
  }

  fetchStatus = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/notifications/stat');
      this.setState({
        status: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  render() {
    const {status} = this.state;
    const {match, history} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <div className="mb-4">
                  <NotificationStats data={status}/>
                </div>
                <NotificationsList history={history}/>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default List;
